/**
 * Created by shahar on 28-Nov-16.
 */
import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot } from '@angular/router';
import {CredentialsCache} from "../../../common/auth/services/service.credentials";

export let __ris_global_vars__:any;

@Injectable()
export class ShellAuthGuard  {
	constructor( private router: Router, private cred:CredentialsCache) {
	}

	canLoad(route:Route) {
		if (this.cred.isTokenSet()) {
			return true;
		} else {
			// since angular doesnt supply the RouteStateSnapshot we have to rely on our own implementation.
			// keep track of pull request https://github.com/angular/angular/pull/13127
			let queryParams=this.readQueryParams();
			queryParams["redirect"]=this.readUrlPath();
			this.router.navigate(["/login"],{queryParams});

			return false;
		}
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		if (this.cred.isTokenSet()){
			return true;
		}else{
			// important to preserve the query parameters since they may have the username/password and other info
			// required for the login, but preserving the current params and adding more leads to a bug

			let urlFromRoot="";
			urlFromRoot=this.extractRoot(state.root);
			urlFromRoot = urlFromRoot.slice(0, urlFromRoot.length-1);// remove last /
			// notice using the route.url is not so good since it includes all the optional parameters
			let newNavParams = Object.assign({redirect:urlFromRoot},route.queryParams);

			this.router.navigate(['/login'],{queryParams:newNavParams});//navigationExtras
			// return is not really relevant
			return false;
		}
	}

	// currently not used since we dont have any child routes configured, but here so we dont miss it in case
	// we add routes
	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		return this.canActivate(route, state);
	}

	public extractRoot(t:ActivatedRouteSnapshot){
		if (t.firstChild) {
			let firstChild=this.extractRoot(t.firstChild);
			let finalUrl=t.url.toString();
			if (!t.url.toString().endsWith("/") && !firstChild.startsWith("/")){
				finalUrl=finalUrl+"/";
			}
			finalUrl=finalUrl+firstChild;
			if (!finalUrl.endsWith("/")){
				finalUrl=finalUrl+"/";
			}
			return finalUrl;
		}else{
			return t.url.toString();
		}
	}

	// temp code until angular merges PR 13127
	private readUrlPath(){
		return window.location.pathname.substr(window["__ris_global_vars__"].baseResourceUrl.length-1);
	}
	// temp code until angular merges PR 13127
	private readQueryParams(){
		let paramValArr=window.location.search.substr(1).split('&');
		// if (paramValArr === []) {
		// 	return {};
		// }
		let paramObjs = {};
		for (let i = 0; i < paramValArr.length; ++i){
			if (paramValArr[i]!=="") {
				let p = paramValArr[i].split('=', 2);
				if (p.length === 1) {
					paramObjs[p[0]] = "";
				} else {
					paramObjs[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
				}
			}
		}
		return paramObjs;
	}

}
